import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getHomePageListAPI, getLocationPageListApi } from "../apis/common";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import { getQueryString } from "utilities/common";
import { data } from "browserslist";

export const getHomePageList = createAsyncThunk(
  "homePage/getHomePageList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await getHomePageListAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getHomePageStateList = createAsyncThunk('homePage/getHomePageStateList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientHyperWolf.get(
        '/api/v1/admin/state/list',
        {
          params: {
            limit: 1000,
          },
        }
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
)


export const getLocationPageCityList = createAsyncThunk('locationPage/getLocationPageCityList',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientHyperWolf.get(
        '/api/v1/admin/city/list',
        {
          params: {
            limit: 1000,
          },
        }
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
)

export const getHomePageById = createAsyncThunk(
  "homePage/getHomePageById",
  async ({ id, isDefaultHomePage }, { rejectWithValue }) => {
    try {
      let res;

      if (isDefaultHomePage) {
        res = await axiosClientHyperWolf.get(
          `/api/v1/admin/home/page/default`
        );

      } else {
        res = await axiosClientHyperWolf.get(
          `/api/v1/admin/home/page/${id}`
        );

      }

      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createHomepageHit = createAsyncThunk(
  "homePage/createHomepageHit",
  async ({ payload, id, isDefaultHomePage }, { rejectWithValue }) => {
    try {
      let res;
      if (isDefaultHomePage) {
        res = await axiosClientHyperWolf.put(`/api/v1/admin/home/page/default`, payload)
      }
      else if (id) {
        res = await axiosClientHyperWolf.put(`/api/v1/admin/home/page/${id}`, payload);
      }
      else {
        res = await axiosClientHyperWolf.post(`/api/v1/admin/home/page/create`, payload);
      }
      return res;
    } catch (error) {
      // Defensive: sometimes error.response may not exist
      const errPayload = error?.response?.data || error?.message || "Unknown error";
      return rejectWithValue(errPayload);
    }
  }
);
//  location page

export const getStates = createAsyncThunk(
  "homePage/getStates",
  async (data, { rejectWithValue }) => {
    try {
      // if (!data.stateCode) return;
      const res = await axiosClientHyperWolf.get(
        `api/v1/admin/home/page/states?${getQueryString(data)}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
)

export const getLocationPageList = createAsyncThunk(
  "homePage/getLocationPageList",
  async (data, { rejectWithValue }) => {
    try {
      // if (!data.stateCode) return;
      const res = await axiosClientHyperWolf.get(
        `/api/v1/admin/location/page?${getQueryString(data)}&userType=admin`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteHomePageState = createAsyncThunk(
  "homePage/deleteHomePageState",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientHyperWolf.delete(`/api/v1/admin/home/page/${data}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteLocation = createAsyncThunk(
  "homePage/deleteLocation",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientHyperWolf.delete(`/api/v1/admin/location/page/${data}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const CreateLocationHit = createAsyncThunk(
  "homePage/CreateLocationHit",
  async ({ payload, locationId }, { rejectWithValue }) => {
    try {
      let res;
      if (locationId) {
        res = await axiosClientHyperWolf.put(`/api/v1/admin/location/page/${locationId}`, payload);
      } else {
        res = await axiosClientHyperWolf.post(`/api/v1/admin/location/page/create`, payload);
      }
      return res;
    } catch (error) {
      // Defensive: sometimes error.response may not exist
      const errPayload = error?.response?.data || error?.message || "Unknown error";
      return rejectWithValue(errPayload);
    }
  }
);

export const getLocationById = createAsyncThunk(
  "homePage/getLocationById",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axiosClientHyperWolf.get(`/api/v1/admin/location/page/${data}`);
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchSlug = createAsyncThunk(
  "homePage/fetchSlug",
  async (payload, { rejectWithValue }) => {
    try {
      let res;
      res = await axiosClientHyperWolf.post(`/api/v1/admin/location/page/location-slug`, payload);
      return res;
    } catch (error) {
      // Defensive: sometimes error.response may not exist
      const errPayload = error?.response?.data || error?.message || "Unknown error";
      return rejectWithValue(errPayload);
    }
  }
);

//Create a slice
const homePageSlice = createSlice({
  name: "homePage",
  initialState: {
    loading: false,
    homePageList: {},
    liveStates: [],
  },
  reducers: {
    setLiveStates: (state, action) => {
      const incoming = action.payload;

      const map = new Map();


      state.liveStates.forEach((item) => {
        map.set(item.stateCode, item);
      });


      incoming.forEach((item) => {
        map.set(item.stateCode, item);
      });

      state.liveStates = Array.from(map.values());
    },

    clearLiveStates: (state) => {
      state.liveStates = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomePageList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHomePageList.fulfilled, (state, action) => {
        state.loading = false;
        state.homePageList = action.payload;
      })
      .addCase(getHomePageList.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(getHomePageById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHomePageById.fulfilled, (state, action) => {
        state.loading = false;
        state.homePageData = action.payload;
      })
      .addCase(getHomePageById.rejected, (state) => {
        state.loading = false;
      });
    // getHomePageStateList
    builder
      .addCase(getHomePageStateList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHomePageStateList.fulfilled, (state, action) => {
        state.loading = false;
        state.homePageData = action.payload;
      })
      .addCase(getHomePageStateList.rejected, (state) => {
        state.loading = false;
      });




    //  Location
    builder
      .addCase(getLocationPageList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocationPageList.fulfilled, (state, action) => {
        state.loading = false;
        state.locationPageList = action.payload;
      })
      .addCase(getLocationPageList.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(createHomepageHit.pending, (state) => {
        state.updateloading = true;
      })
      .addCase(createHomepageHit.fulfilled, (state, action) => {
        state.updateloading = false;
      })
      .addCase(createHomepageHit.rejected, (state) => {
        state.updateloading = false;
      });
    //  Create Location
    builder
      .addCase(CreateLocationHit.pending, (state) => {
        state.updateloading = true;
      })
      .addCase(CreateLocationHit.fulfilled, (state, action) => {
        state.updateloading = false;
      })
      .addCase(CreateLocationHit.rejected, (state) => {
        state.updateloading = false;
      });

    builder
      .addCase(getLocationById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocationById.fulfilled, (state, action) => {
        state.loading = false;
        state.locationPageData = action.payload;
      })
      .addCase(getLocationById.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchSlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSlug.fulfilled, (state, action) => {
        state.loading = false;
        state.slugData = action.payload;
      })
      .addCase(fetchSlug.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  /* Any additional actions */
  setLiveStates
} = homePageSlice.actions;

export default homePageSlice.reducer;
